export default __webpack_public_path__ + "static/media/15_DbeBw0Vg-min.bd91d534.jpeg";